import React, { Component } from "react";

import Searchbar from "../../utils/Searchbar";
import SearchOrderCustomer from "../../search/SearchOrderCustomer";

class OrderSearch extends Component {
	render() {
		return (
			<div>
				<Searchbar placeholder={"Search orders"} component={SearchOrderCustomer} searchEndpoint={"search/orders"} {...this.props} userType="customer" />
			</div>
		);
	}
}

export default OrderSearch;



// WEBPACK FOOTER //
// ./src/components/customer/orders/OrderSearch.js